import { ChangeDetectorRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AccessString, AuthService } from 'providers/auth.service';
import { RequireAccessAnyDirective } from './requireAccessAny.directive';

/**
 * Like *ngIf but checks for a specific permission.
 *
 * @deprecated Please use *requireAccessAny directive
 */
@Directive({
    selector: '[ceAccess]',
})
@UntilDestroy()
export class CeAccessDirective extends RequireAccessAnyDirective {
    @Input('ceAccess') set accessString(accessString: AccessString) {
        this.accessString$.next(accessString);
    }

    constructor(
        templateRef: TemplateRef<any>,
        viewContainerRef: ViewContainerRef,
        authService: AuthService,
        cdRef: ChangeDetectorRef
    ) {
        super(templateRef, viewContainerRef, authService, cdRef);
    }
}
